var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState, useEffect, useRef } from "react";
import useDraggableScroll from "use-draggable-scroll";
import { SlipData } from "./ResultHistory.slip";
import { SeedSettings } from "../SeedSettings/SeedSettings";
import { ResultHistoryWrapper, AnimatedButtonWrapper, } from "./ResultHistory.styled";
import Button from "../../ui/Button/Button";
import Modal from "../../ui/Modal/Modal";
import { useGameContext } from "../../game/GameContext/GameContext";
import SeedSettingsIcon from "../../assets/seedSettingsIcon";
var ResultHistory = function (_a) {
    var seedSettingsCalls = _a.seedSettingsCalls;
    var getGameData = seedSettingsCalls.getGameData, getNonceData = seedSettingsCalls.getNonceData, session_id = seedSettingsCalls.session_id;
    var gameResults = useGameContext().gameResults;
    var wrapperRef = useRef(null);
    var onMouseDown = useDraggableScroll(wrapperRef, {
        direction: "horizontal",
    }).onMouseDown;
    var _b = useState(false), seedSettingsModalOpen = _b[0], setSeedSettingsModalOpen = _b[1];
    var _c = useState(false), betSlipModalOpen = _c[0], setBetSlipModalOpen = _c[1];
    var _d = useState(null), betSlipModalData = _d[0], setBetSlipModalData = _d[1];
    var openBetSlipModal = function (betResource) {
        setBetSlipModalData(_jsx(SlipData, { betResource: betResource }));
        setBetSlipModalOpen(true);
    };
    var closeBetSlipModal = function () {
        setBetSlipModalData(null);
        setBetSlipModalOpen(false);
    };
    var controlSeedSettingsModal = function (open) {
        setSeedSettingsModalOpen(open);
    };
    var _e = useState([]), localResults = _e[0], setLocalResults = _e[1];
    useEffect(function () {
        setLocalResults(function (prevResults) {
            var addedItems = gameResults.filter(function (newItem) { return !prevResults.some(function (oldItem) { return oldItem.hash === newItem.hash; }); });
            var removedItems = prevResults.filter(function (oldItem) { return !gameResults.some(function (newItem) { return newItem.hash === oldItem.hash; }); });
            return __spreadArray(__spreadArray([], addedItems.map(function (item) { return (__assign(__assign({}, item), { animationState: "enter" })); }), true), prevResults.map(function (item) {
                return removedItems.some(function (removed) { return removed.hash === item.hash; })
                    ? __assign(__assign({}, item), { animationState: "exit" }) : __assign(__assign({}, item), { animationState: "move-left" });
            }), true);
        });
    }, [gameResults]);
    var handleAnimationEnd = function (itemHash, animationState) {
        if (animationState === "exit") {
            setLocalResults(function (prev) { return prev.filter(function (item) { return item.hash !== itemHash; }); });
        }
        else {
            setLocalResults(function (prev) {
                return prev.map(function (item) {
                    return item.hash === itemHash ? __assign(__assign({}, item), { animationState: "static" }) : item;
                });
            });
        }
    };
    return (_jsxs(_Fragment, { children: [_jsx(Modal, { isOpen: betSlipModalOpen, onClose: closeBetSlipModal, closeButton: true, title: "Bet Slip", contents: betSlipModalData }), _jsx(Modal, { isOpen: seedSettingsModalOpen, onClose: function () { return controlSeedSettingsModal(false); }, closeButton: true, title: "Seed Settings", contents: _jsx(SeedSettings, { useNew: function () { return controlSeedSettingsModal(false); }, getGameData: getGameData, getNonceData: getNonceData, session_id: session_id }) }), _jsxs(ResultHistoryWrapper, { ref: wrapperRef, onMouseDown: onMouseDown, children: [_jsx(Button, { variant: "infoButtonNegative", onClick: function () { return controlSeedSettingsModal(true); }, children: _jsx(SeedSettingsIcon, {}) }), localResults.map(function (betResource) {
                        var animationState = betResource.animationState, multiplier = betResource.multiplier, isWin = betResource.isWin;
                        var resultContext = isWin ? "infoButtonPositive" : "infoButtonNegative";
                        var buttonText = "".concat(isWin ? Math.floor(multiplier * 100) / 100 : 0, "x");
                        return (_jsx(AnimatedButtonWrapper, { animationState: animationState, onAnimationEnd: function () {
                                return handleAnimationEnd(betResource.hash, animationState);
                            }, children: _jsx(Button, { variant: resultContext, onClick: function () { return openBetSlipModal(betResource); }, children: buttonText }) }, betResource.hash));
                    })] })] }));
};
ResultHistory.displayName = "ResultHistory";
export default ResultHistory;
//# sourceMappingURL=ResultHistory.js.map